import { darkColors, lightColors } from '@tryhackme/thm-ui-components';
import styled, { keyframes, css } from 'styled-components';

import {
  CommonBadgeStyles,
  CommonContentStyles,
  CommonHeaderContentStyles,
  DarkModeMainAdjustmentStyles,
  MainContentBadgeStyles,
} from 'src/common/legacy-styles';
import { TextAndBackgroundColorStyles } from 'src/common/legacy-styles/text-and-bg-color';
import { RoomHeaderStyles } from 'src/common/styles';

export const realStyles = css`
  ${CommonHeaderContentStyles}
  ${RoomHeaderStyles}
  ${TextAndBackgroundColorStyles}
  ${CommonBadgeStyles}
  ${MainContentBadgeStyles}
  ${DarkModeMainAdjustmentStyles}
  ${CommonContentStyles}
`;

export const rawSummernoteStyles = css`
  /* summernote bugfixes for our existing styling */
  // make sure the below popups are wide enough to fit their contents
  // defaults end up being too narrow for our styling
  .note-popover .popover-content .note-color-all .note-dropdown-menu,
  .note-editor .note-toolbar .note-color-all .note-dropdown-menu {
    min-width: 342px;
  }
  .note-popover .popover-content .note-para .note-dropdown-menu,
  .note-editor .note-toolbar .note-para .note-dropdown-menu {
    min-width: 229px;
  }

  /* summernote styling overrides to match design */
  .note-toolbar {
    border-bottom-color: transparent;
    background-color: transparent;
    color: ${({ $isDark }) => ($isDark ? darkColors.text.light : lightColors.text.main)};
    p {
      color: ${({ $isDark }) => ($isDark ? darkColors.text.light : lightColors.text.main)} !important;
    }
    .btn-default {
      color: ${({ theme }) => theme.colors.text.main};
      background-color: ${({ theme }) => theme.colors.button.secondary.border};
      &:hover,
      &:focus,
      .focus {
        color: ${({ theme }) => theme.colors.black};
        background-color: ${({ theme }) => theme.colors.button.secondary.hover};
      }
    }
  }

  .note-tooltip {
    .note-tooltip-content {
      border-radius: 0.5rem;
    }
  }

  && :not(.note-btn-group) > .note-btn-group {
    margin-right: 0;
  }

  &&& .note-btn-group > .note-btn {
    border-color: transparent;
    background-color: transparent;
    box-shadow: none;
    border-radius: 0.5rem;
    color: ${({ $isDark }) => ($isDark ? darkColors.text.light : lightColors.text.main)};

    &:hover,
    &:focus,
    .focus {
      background-color: ${({ theme }) => theme.colors.background.tableRowHover};
      color: ${lightColors.text.main} !important;
    }

    &.active {
      background-color: ${({ theme }) => theme.colors.background.grey};
      color: ${lightColors.text.main} !important;
    }

    margin-right: 0.5rem;

    &.note-current-color-button {
      margin-right: 0;
    }
  }

  .note-dropdown-menu {
    margin-top: 0.5rem;
    background-color: ${({ $isDark }) => ($isDark ? darkColors.background.dark : lightColors.background.light)};
    border-radius: 0.5rem;
    border-color: ${({ theme }) => theme.colors.border.light};
  }

  .note-editor.note-frame {
    font-family: inherit;
    ${RoomHeaderStyles}
    // Match legacy room display
      ${TextAndBackgroundColorStyles}
      border-radius: 0.5rem;
    border-color: ${({ theme }) => theme.colors.border.light};
    .note-statusbar {
      border-top-color: ${({ theme }) => theme.colors.border.light};
      background-color: ${({ theme }) => theme.colors.background.tableOdd};
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
      .note-resizebar .note-icon-bar {
        border-color: ${({ theme }) => theme.colors.border.light};
      }
    }
    .note-tooltip {
      &.in {
        opacity: 1;
      }
      &.bottom .note-tooltip-arrow {
        border-bottom-color: ${({ theme }) => theme.colors.background.tertiary};
      }
      &.top .note-tooltip-arrow {
        border-top-color: ${({ theme }) => theme.colors.background.tertiary};
      }
      &.right .note-tooltip-arrow {
        border-right-color: ${({ theme }) => theme.colors.background.tertiary};
      }
      &.left .note-tooltip-arrow {
        border-left-color: ${({ theme }) => theme.colors.background.tertiary};
      }
    }
    .note-tooltip-content {
      font-family: inherit;
      ${TextAndBackgroundColorStyles}
      box-shadow: ${({ theme }) => theme.boxShadow.main};
    }
    .note-popover {
      background-color: ${({ theme }) => theme.colors.background.main};
      border-color: ${({ theme }) => theme.colors.border.light};
      border-radius: 0.5rem;
      &.bottom .note-popover-arrow {
        border-bottom-color: ${({ theme }) => theme.colors.border.light};
        &::after {
          border-bottom-color: ${({ theme }) => theme.colors.background.main};
        }
      }
      &.top .note-popover-arrow {
        border-top-color: ${({ theme }) => theme.colors.border.light};
        &::after {
          border-top-color: ${({ theme }) => theme.colors.background.main};
        }
      }
      &.right .note-popover-arrow {
        border-right-color: ${({ theme }) => theme.colors.border.light};
        &::after {
          border-right-color: ${({ theme }) => theme.colors.background.main};
        }
      }
      &.left .note-popover-arrow {
        border-left-color: ${({ theme }) => theme.colors.border.light};
        &::after {
          border-left-color: ${({ theme }) => theme.colors.background.main};
        }
      }
    }
    .note-modal-content {
      &,
      * {
        ${TextAndBackgroundColorStyles}
        border-color: ${({ theme }) => theme.colors.border.light};
      }
      font-size: 1.6rem;
      input[type='text'] {
        font-family: ${({ theme }) => theme.fonts.familySansPro};
        border-radius: 0.5rem;
        padding: 0.7rem 1.2rem 0.7rem 1.6rem;
      }
      input[type='checkbox'] {
        margin-right: 0.5rem;
        accent-color: ${({ theme }) => theme.colors.success.main};
      }
      .note-modal-header {
        padding: 2.6rem 2.6rem 1rem 2.6rem;
        border: none;
      }
      .note-modal-title {
        padding-left: 2rem;
      }
      .note-modal-body {
        padding-left: 4.6rem;
        padding-right: 4.6rem;
      }
      .note-modal-footer {
        height: auto;
        display: flex;
        justify-content: flex-end;
        padding-bottom: 3rem;
        padding-left: 4.6rem;
        padding-right: 4.6rem;
      }
      .note-link-btn {
        font-family: ${({ theme }) => theme.fonts.familyUbuntu};
        border-radius: 0.5rem;
        background-color: ${({ theme }) => theme.colors.primary.main};
      }
    }
  }

  &&& .note-placeholder {
    padding: 0 1.6rem 1.4rem;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }

  &&&& .note-editable {
    padding: 0 1.6rem 1.4rem;
  }

  .note-current-fontname {
    color: ${({ theme }) => theme.colors.black} !important;
  }

  .note-current-fontsize {
    color: ${({ theme }) => theme.colors.black} !important;
  }

  .note-dropdown-item:not(:hover) > span {
    color: ${({ $isDark }) => ($isDark ? darkColors.text.light : lightColors.text.main)} !important;
  }

  a {
    &.note-dropdown-item {
      color: ${({ $isDark }) => ($isDark ? darkColors.text.light : lightColors.text.main)} !important;
    }
    &.note-dropdown-item:hover {
      color: ${({ theme }) => theme.colors.black} !important;
    }
  }

  .note-btn:not(:hover):not(.active) > span {
    color: ${({ $isDark }) => ($isDark ? darkColors.text.light : lightColors.text.main)} !important;
  }

  .panel-heading.note-toolbar .note-para .dropdown-toggle.list-styles {
    width: 2rem;
    padding-left: 0.5rem;
  }

  .panel-heading.note-toolbar .dropdown-list-styles {
    padding: 0.5rem 0 !important;
    min-width: 12rem !important;
  }

  .note-dropdown-menu {
    list-style-type: none !important;
  }

  .dropdown-list-styles > li > a > ol {
    margin-bottom: 0;
  }

  /* style (un)overrides and legacy styles to match legacy room display */
  .note-editor .note-editing-area .note-editable {
    ${CommonHeaderContentStyles}
    ${TextAndBackgroundColorStyles}
      ${CommonBadgeStyles}
      ${MainContentBadgeStyles}
      ${DarkModeMainAdjustmentStyles}
      ${CommonContentStyles}
  }
`;

export const StyledSummernoteStylesWrapper = styled.div<{ $isDark: boolean }>`
  ${rawSummernoteStyles}
`;

const placeHolderShimmer = keyframes` 

  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 0 0;
  }
`;

export const StyledSummernoteSkeleton = styled.div`
  height: 16rem;
  border-radius: 0.5rem;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.loading.primary},
    ${({ theme }) => theme.colors.loading.secondary},
    ${({ theme }) => theme.colors.loading.primary}
  );
  background-size: 1000px;
  animation: ${placeHolderShimmer} 2s linear infinite;
`;
